// @core/api/endpoints/payment/list_payment_types.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPaymentTypesResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * List payment types
 * Returns all registered payment types, optionally filtered by product.
 */
export async function ListPaymentTypes(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    product_id?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListPaymentTypesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payment-types`;
  const requestOptions = options;
  return client.get<ListPaymentTypesResponse>(requestPath, { ...requestOptions, params });
}
